module.exports = __webpack_public_path__ + "static/media/02_Timeline_district_1.9649a364.webp";